import React from "react";
import cssClasses from "./OnlineBookingConfig.module.css";
import { Box } from "@mui/material";
import DateComponent from "../../Subcomponents/DateComponent";
import DropDown from "../../Subcomponents/DropDown";
import CustomRadio from "../../Subcomponents/CustomRadio";
import { useState } from "react";
import { errorTost } from "../../Services/Toast";
import CustomInput from "../../Subcomponents/CustomInput";
import RupeeIcon from "../../Assets/Images/Sustenance/RupeeIcon.svg";
import CustomToggle from "../../Subcomponents/Toggle/CustomToggle";

const OnlineBookingConfig = ({
  eventTokens,
  setEventTokens,
  index,
  launchWiseToken,
}) => {
  return eventTokens?.token?.length > 0
    ? eventTokens.token?.map((val, inx) => {
        console.log("online---->", val);
        console.log("launch wise token in online ", launchWiseToken);

        return (
          <Box className={cssClasses.mainTabPanelWrapper} sty>
            <span
              style={{
                fontSize: "2rem",
                fontFamily: "inter-semibold",
                paddingBottom: "2rem",
              }}
            >
              {val?.eventTokenId?.tokenId.name}
            </span>
            <div style={{ marginBottom: "2rem" }}>
              <div
                style={{ paddingBottom: "2rem" }}
                className={cssClasses.header}
              >
                <p className={cssClasses.headerText}>Online Booking Config</p>
              </div>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "3rem",
                  flexWrap: "wrap",
                }}
              >
                <DateComponent
                  helperText=""
                  label="Start Date Time"
                  maxDate={val?.Enddate ? new Date(val.Enddate) : null}
                  value={
                    val?.Startdate
                      ? new Date(val.Startdate) // ✅ Display local time equivalent of stored UTC
                      : new Date()
                  }
                  onChangeDate={(e) => {
                    const payload = [...launchWiseToken];

                    // ✅ Always store UTC timestamp (milliseconds since epoch)
                    // This ensures consistency across all users and servers
                    payload[index].token[inx].Startdate = e
                      ? new Date(e).getTime()
                      : null;

                    setEventTokens(payload);
                  }}
                />

                <DateComponent
                  helperText=""
                  label="End Date Time"
                  minDate={val?.Startdate ? new Date(val.Startdate) : null}
                  value={
                    val?.Enddate
                      ? new Date(val.Enddate) // ✅ Display local time equivalent of stored UTC
                      : new Date()
                  }
                  onChangeDate={(e) => {
                    const payload = [...launchWiseToken];

                    // ✅ Store as UTC timestamp (no local offset applied)
                    payload[index].token[inx].Enddate = e
                      ? new Date(e).getTime()
                      : null;

                    setEventTokens(payload);
                  }}
                />

                <div className={cssClasses.labelToggleWrapper}>
                  <div style={{ flex: "25%" }}>
                    <p className={cssClasses.toggleLabel}>
                      Allow Online Booking:
                    </p>
                  </div>
                  <div style={{ flex: "75%" }}>

                    <CustomToggle
                      checked={Boolean(
                        val?.Isonlinebookingaccept === true ||
                          val?.Isonlinebookingaccept === "true"
                      )}
                      setChecked={() => {
                        const payload = [...launchWiseToken];
                        payload[index].token[inx].Isonlinebookingaccept =
                          !Boolean(
                            payload[index].token[inx].Isonlinebookingaccept ===
                              true ||
                              payload[index].token[inx]
                                .Isonlinebookingaccept === "true"
                          );
                        setEventTokens(payload);
                      }}
                    />
                  </div>
                </div>


              {/* cancellation toggle */}
                <div className={cssClasses.labelToggleWrapper}>
                  <div style={{ flex: "25%" }}>
                    <p className={cssClasses.toggleLabel}>
                      Allow Online Cancellation:
                    </p>
                  </div>
                  <div style={{ flex: "75%" }}>

                    <CustomToggle
                      checked={Boolean(
                        val?.allowAutoCancellation === true ||
                          val?.allowAutoCancellation === "true"
                      )}
                      setChecked={() => {
                        const payload = [...launchWiseToken];
                        payload[index].token[inx].allowAutoCancellation =
                          !Boolean(
                            payload[index].token[inx].allowAutoCancellation ===
                              true ||
                              payload[index].token[inx]
                                .allowAutoCancellation === "true"
                          );
                        setEventTokens(payload);
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>

            <div></div>
            {/* {eventTokens?.token?.length > 0 && (
            <div style={{ marginTop: "2rem" }}>
              <div
                style={{ paddingBottom: "2rem" }}
                className={cssClasses.header}
              >
                <p className={cssClasses.headerText}>Confirmation Config</p>
              </div>
              {
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "2rem",
                    fontSize: "1.6rem",
                  }}
                >
                  <CustomRadio
                    value={
                      val.autoConfirmation
                        ? "Auto Confirmation"
                        : "Lead Confirmation"
                    }
                    optionList={["Auto Confirmation", "Lead Confirmation"]}
                    onChangeValue={(e) => {
                      if (
                        new Date().getTime() >
                        val?.eventTokenId?.startDateTime &&
                        new Date().getTime() < val?.eventTokenId?.endDateTime
                      ) {
                        const payload = [...launchWiseToken];
                        payload[index].token[inx].autoConfirmation =
                          e === "Auto Confirmation" ? true : false;
                        setEventTokens(payload);
                      } else {
                        errorTost(
                          "Auto Confirmation is only allowed on event day"
                        );
                      }
                    }}
                  />
                </div>
              }
            </div>
          )} */}
            {/* {val?.eventTokenId?.prerequisiteId && (
            <div style={{ marginTop: "2rem" }}>
              <div
                style={{ paddingBottom: "2rem" }}
                className={cssClasses.header}
              >
                <p className={cssClasses.headerText}>Prerequisite Checkpoints</p>
              </div>
              <div style={{display:"flex",gap:"2rem"}}>
              <div
                  style={{
                    display: "flex",
                    alignItems: "stretch",
                  }}
                >
                  <div>
                    <label class={cssClasses.container}>
                      <input
                        class={cssClasses.checkbox}
                        type="checkbox"
                        name=""
                        id=""
                        onChange={(e) => {
                          const payload = [...launchWiseToken];
                          payload[index].token[inx].checkpoint =
                            payload[index].token[inx].checkpoint
                              ? payload[index].token[inx].checkpoint
                              : {};
                          if (
                            payload[index].token[
                              inx
                            ].checkpoint?.checkpoint1
                          ) {
                            payload[index].token[
                              inx
                            ].checkpoint.checkpoint1 = false
                          } else {
                            payload[index].token[
                              inx
                            ].checkpoint.checkpoint1 = true
                          }
                          setEventTokens(payload);
                        }}
                        checked={val?.checkpoint?.checkpoint1}
                      />
                      <span class={cssClasses.checkmark}></span>
                    </label>
                  </div>
                  <p className={cssClasses.toggleLabel}>Checkpoint1</p>
                </div>

                <div
                  style={{
                    display: "flex",
                    alignItems: "stretch",
                  }}
                >
                  <div>
                    <label class={cssClasses.container}>
                      <input
                        class={cssClasses.checkbox}
                        type="checkbox"
                        name=""
                        id=""
                        onChange={(e) => {
                          const payload = [...launchWiseToken];
                          payload[index].token[inx].checkpoint =
                            payload[index].token[inx].checkpoint
                              ? payload[index].token[inx].checkpoint
                              : {};
                          if (
                            payload[index].token[
                              inx
                            ].checkpoint?.checkpoint2
                          ) {
                            payload[index].token[
                              inx
                            ].checkpoint.checkpoint2 = false
                          } else {
                            payload[index].token[
                              inx
                            ].checkpoint.checkpoint2 = true
                          }
                          setEventTokens(payload);
                        }}
                        checked={val?.checkpoint?.checkpoint2}
                      />
                      <span class={cssClasses.checkmark}></span>
                    </label>
                  </div>
                  <p className={cssClasses.toggleLabel}>Checkpoint2</p>
                </div>
                </div>
            </div>
          )} */}
          </Box>
        );
      })
    : "";
};

export default OnlineBookingConfig;
